import { useCallback } from "react";
import { Toaster, toast } from "sonner";
import Preloader from "../components/landing/Preloader";
import Navigation from "../components/landing/Navigation";
import Hero from "../components/landing/Hero";
import StatsBar from "../components/landing/StatsBar";
import FeaturedTrips from "../components/landing/FeaturedTrips";
import TransferService from "../components/landing/TransferService";
import SmartFeatures from "../components/landing/SmartFeatures";
import WhyUs from "../components/landing/WhyUs";
import ExperienceIntro from "../components/landing/ExperienceIntro";
import Reviews from "../components/landing/Reviews";
import ContactCTA from "../components/landing/ContactCTA";
import Footer from "../components/landing/Footer";
import { useTranslation } from "../i18n/LanguageContext";

export default function Landing() {
  const { t } = useTranslation();

  const scrollToQuote = useCallback(() => {
    document
      .getElementById("kapcsolat")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const handleCallback = useCallback(() => {
    toast.success(t.toast.callback.title, {
      description: t.toast.callback.desc,
    });
  }, [t]);

  return (
    <div className="App relative">
      <Preloader />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(245,239,251,0.95)",
            border: "1px solid rgba(197,160,89,0.35)",
            color: "#0a0a0a",
            backdropFilter: "blur(20px)",
          },
        }}
      />
      <Navigation onQuoteClick={scrollToQuote} />
      <Hero onQuoteClick={scrollToQuote} />
      <StatsBar />
      <FeaturedTrips onQuoteClick={scrollToQuote} />
      <TransferService onQuoteClick={scrollToQuote} />
      <SmartFeatures
        onQuoteClick={scrollToQuote}
        onCallbackClick={handleCallback}
      />
      <WhyUs />
      <ExperienceIntro />
      <Reviews />
      <ContactCTA />
      <Footer />
    </div>
  );
}
